<template>
	<div class="spacer">
		<v-footer ref="footer" color="primary" dark class="ma-0 pt-4 pb-5 footer">			
			<v-row>
				<v-col>
					<router-link to="/hintergrund">Hintergrund</router-link><br/>
					<router-link to="/kontakt">Kontakt</router-link>
				</v-col>
				<v-col>
					<router-link to="/funktion">Funktion </router-link><br/>
					<router-link to="/vorteile">Vorteile </router-link> <br/>
				</v-col>
				<v-col>
					<b class="cn-font bold">CIN Service GmbH</b><br/>
					Analyse klinischer Versorgungsprozesse<br/>
					T +49 (0) 30 206 22 58 – 20
					<p>Friedrichstraße 200<br/>
					D – 10117 Berlin</p>
					<p><router-link to="/impressum">Impressum /<br/>
					Datenschutz</router-link></p>
				</v-col>
			</v-row>
		</v-footer>
	</div>
</template>
<style scoped lang="less">
	.spacer{
		.footer{
			font-size: 0.8em;
			a{
				text-decoration: none;
				color: white !important;
				&:hover{
					text-decoration: underline;
				}
			}
		}
	}
</style>
<script>
	export default {
		name: "Footer",
	}
</script>


